<template>
  <div>
    <!-- Marriages -->
    <div>
      <MarriagesCard
        v-for="marriage of peParty.spouses"
        :key="marriage.id"
        :item="marriage"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <MarriagesCard
        v-for="item of partySurveyCardsByIdentifiers('marriages-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Marriage"
      :has-new-section="peMarriagesCardHasNewSection"
      @on-add="peMarriagesCardAddSection"
    />

    <!-- Children -->
    <div>
      <ChildrenCard
        v-for="child of peParty.children"
        :key="child.id"
        :item="child"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <ChildrenCard
        v-for="item of partySurveyCardsByIdentifiers('children-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Child"
      :has-new-section="peChildrenCardHasNewSection"
      @on-add="peChildrenCardAddSection"
    />

    <!-- Parents -->
    <div>
      <ParentsCard
        v-for="parent of peParty.parents"
        :key="parent.id"
        :item="parent"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <ParentsCard
        v-for="item of partySurveyCardsByIdentifiers('parents-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Parent"
      :has-new-section="peParentsCardHasNewSection"
      @on-add="peParentsCardAddSection"
    />

    <!-- Parents -->
    <div>
      <SiblingsCard
        v-for="sibling of peParty.siblings"
        :key="sibling.id"
        :item="sibling"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <SiblingsCard
        v-for="item of partySurveyCardsByIdentifiers('siblings-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Sibling"
      :has-new-section="peSiblingsCardHasNewSection"
      @on-add="peSiblingsCardAddSection"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'

import { PARTY_NAMESPACE } from '@/store/party'

import ChildrenCard from './SectionCards/FamiliesCards/ChildrenCard'
import MarriagesCard from './SectionCards/FamiliesCards/MarriagesCard'
import ParentsCard from './SectionCards/FamiliesCards/ParentsCard'
import SectionAdderLine from './SectionTools/SectionAdderLine'
import SiblingsCard from './SectionCards/FamiliesCards/SiblingsCard'

export default {
  name: 'PEFamilies',

  components: {
    ChildrenCard,
    MarriagesCard,
    ParentsCard,
    SectionAdderLine,
    SiblingsCard,
  },

  beforeRouteLeave (_, __, next) {
    if (this.peAnyUnlockedSections) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.peLockPartySections()
        next()
      } else next(false)
    } else {
      this.peLockPartySections()
      next()
    }
  },

  props: {
    id: {
      type: String || Number,
      required: true,
    },
  },

  setup () {
    return { ...alertHandler() }
  },

  computed: {
    ...mapGetters(PARTY_NAMESPACE, [
      'peAnyUnlockedSections',
      'peChildrenCardHasNewSection',
      'peMarriagesCardHasNewSection',
      'peParentsCardHasNewSection',
      'peParty',
      'peSiblingsCardHasNewSection',
    ]),

    ...mapGetters(PARTY_NAMESPACE, [
      'partySurveyCardsByIdentifiers',
      'peSurveysValidationActive',
    ]),
  },

  created () {
    this.peGetPartySection({ id: this.id }).
      catch(() => this.displayAlert('error', `No Party found with the id: ${this.id}`))
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peChildrenCardAddSection',
      'peGetPartySection',
      'peLockPartySections',
      'peMarriagesCardAddSection',
      'peParentsCardAddSection',
      'peSiblingsCardAddSection',
    ]),
  },
}
</script>
